<template>
  <div class="header">
    <router-link v-on:click="reset" to="/emailregisteration"
      >{{$t('backToStart')}}</router-link
    >
  </div>
  <div>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phoneNumber: null,
      email: null,
    };
  },

  methods: {
    reset() {
      this.$store.replaceState({});
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+Display:wght@320&display=swap');

* {
  box-sizing: border-box;
}

html {
  font-family: 'Times', serif;
}

body {
  background-color: #eaf8f8;
}

div.content {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

p {
  font-size: 50px;
  width: auto;
  height: max-content;
  font-family: 'Noto Serif Display', serif;
}

.ErrorMessage {
  font-size: 25px;
  font-family: 'Times', serif;
}

input::placeholder {
  opacity: 0.2;
}

div.header {
  margin-left: 50px;
  margin-top: 50px;
  font-size: 25px;
}

div.pagenumber {
  position: absolute;
  bottom: 0px;
  right: 0px;
  font-size: 25px;
  margin-right: 50px;
  margin-bottom: 50px;
}
</style>
